import React, { useEffect, useState } from "react";
import { useNavigate, useParams, Link } from "react-router-dom";
import {
  getStaffDetails,
  updateStaff,
} from "../../redux/services/Staff Services/Staff.Services";
import { allActiveRole } from "../../redux/services/RoleService/role.Services";
import { ActiveDepartmentList } from "../../redux/services/DepartmentService/deparment.Services";
import { successToast, errorToast } from "../../Utils/toast";

const permissionsList = [
  // {
  //   label: "Employees",
  //   key: "employees",
  //   children: [
  //     { label: "Employee", key: "staff" },
  //     { label: "Roles", key: "role" },
  //     { label: "Departments", key: "department" },
  //     { label: "Activity", key: "StaffActivity" },
  //   ],
  // },
  {
    label: "Leads",
    key: "lead",
    children: [
      { label: "New", key: "newlead" },
      { label: "Pending", key: "pendinglead" },
      { label: "Others", key: "alllead" },
      { label: "Assigned Lead", key: "LeadAssigned" },
    ],
  },
  {
    label: "Dashboard",
    key: "dashboard",
  },
  // {
  //   label: "Inventory Management",
  //   key: "inventoryManagement",
  //   children: [
  //     { label: "Categories", key: "category" },
  //     { label: "Sub Categories", key: "subcategory" },
  //   ],
  // },
  // {
  //   label: "Task",
  //   key: "task",
  // },
  // {
  //   label: "Chat",
  //   key: "chat",
  // },
  // {
  //   label: "Reminder",
  //   key: "reminder",
  // },
  // {
  //   label: "Meeting",
  //   key: "meeting",
  // },
  // {
  //   label: "Leave",
  //   key: "leave",
  // },
  // {
  //   label: "Calendar",
  //   key: "calendar",
  // },
  // {
  //   label: "Content / Setting",
  //   key: "settings",
  // },
];
const defaultPermissions = permissionsList.reduce((acc, item) => {
  acc[item.key] = 0;
  if (item.children) {
    item.children.forEach((child) => {
      acc[child.key] = 0;
    });
  }
  return acc;
}, {});

function EditStaff() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [roles, setRoles] = useState([]);
  const [departments, setDepartments] = useState([]);
  const [errors, setErrors] = useState({});
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    mobile: "",
    role: "",
    joining_date: "",
    // salary: "",
    department: "",
    department_id: "",
    // password: "",
    address: "",
    status: "",
    permissions: defaultPermissions,
  });
  useEffect(() => {
    const fetchAll = async () => {
      try {
        if (!id) {
          errorToast("Invalid Staff ID in URL");
          return;
        }
        setLoading(true);

        // ✅ Step 1: Departments fetch karo
        const deptRes = await ActiveDepartmentList();
        const deptList = deptRes?.data || [];
        setDepartments(deptList);

        // ✅ Step 2: Roles fetch karo
        const roleRes = await allActiveRole();
        setRoles(roleRes?.data || []);

        // ✅ Step 3: Staff details fetch karo
        const res = await getStaffDetails(id);
        const data = res?.data?.data;
        if (!data) {
          errorToast("Staff not found");
          return;
        }

        // ✅ Permissions convert: Array of Objects -> Flat Object
        // const permissionObj = { ...defaultPermissions };
        // if (Array.isArray(data.permissions)) {
        //   data.permissions.forEach((perm) => {
        //     permissionObj[perm.module] = 1;
        //   });
        // }


        // ✅ Permissions convert: API Name format -> Checkbox Key format
        const permissionObj = { ...defaultPermissions };
        if (Array.isArray(data.permissions)) {
          data.permissions.forEach((perm) => {

            const parentItem = permissionsList.find(
              (item) => item.label.toLowerCase() === String(perm.module).toLowerCase()
            );

            if (parentItem) {
              permissionObj[parentItem.key] = 1;

              if (parentItem.children && Array.isArray(perm.permissions)) {
                parentItem.children.forEach((child) => {
                  if (perm.permissions.includes(child.label)) {
                    permissionObj[child.key] = 1;
                  }
                });
              }
            } else {
              permissionObj[perm.module] = 1;
            }
          });
        }

        // ✅ Department name se id nikaalo
        const staffDeptName = data?.department || "";
        const matchedDept = deptList.find((d) => d.name === staffDeptName);

        setFormData({
          id: data?.id || "",
          name: data?.name || "",
          email: data?.email || "",
          mobile: data?.mobile || "",
          role: data?.role || "",
          joining_date: data?.date ? data.date.split("T")[0] : "",
          // salary: data?.salary || "",
          department: staffDeptName,
          department_id: matchedDept?.id || "",
          // password: data?.simple_pass || "",
          address: data?.address || "",
          // status: data?.status === 1 ? "active" : "inactive",
          status: data?.status === 1 ? 1 : 0,
          permissions: permissionObj,
        });
      } catch (error) {
        console.log(error);
        errorToast("Failed to load staff data");
      } finally {
        setLoading(false);
      }
    };

    fetchAll();
  }, [id]);

  // =========================
  // HANDLE CHANGE
  // =========================
  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => {
      // ✅ Department change hone par department_id update + role reset
      if (name === "department") {
        const selectedDept = departments.find((d) => d.name === value);
        return {
          ...prev,
          department: value,
          department_id: selectedDept?.id || "",
          role: "",
        };
      }

      return {
        ...prev,
        [name]: value,
      };
    });

    if (errors[name]) {
      setErrors((prev) => ({ ...prev, [name]: null }));
    }
  };

  // =========================
  // PERMISSION TOGGLE
  // =========================
  const handlePermissionTogglecheck = (key, children = []) => {
    setFormData((prev) => {
      const updatedPermissions = { ...prev.permissions };
      const isChecked = updatedPermissions[key] === 1 ? 0 : 1;

      if (children.length > 0) {
        updatedPermissions[key] = isChecked;
        children.forEach((child) => {
          updatedPermissions[child.key] = isChecked;
        });
      } else {
        updatedPermissions[key] = isChecked;

        // const parentItem = permissionsList.find((item) =>
        //   item.children?.some((child) => child.key === key)
        // );
const parentItem = permissionsList.find((item) =>
  item.children?.some((child) => child.key === key)
);
        if (parentItem) {
          const allChildrenChecked = parentItem.children.every(
            (child) => updatedPermissions[child.key] === 1
          );
          const anyChildChecked = parentItem.children.some(
            (child) => updatedPermissions[child.key] === 1
          );

          if (allChildrenChecked) {
            updatedPermissions[parentItem.key] = 1;
          } else if (!anyChildChecked) {
            updatedPermissions[parentItem.key] = 0;
          }
        }
      }

      return { ...prev, permissions: updatedPermissions };
    });
  };

  const handleSelectAll = (e) => {
    const isChecked = e.target.checked;
    setFormData((prev) => {
      const updatedPermissions = { ...prev.permissions };
      Object.keys(updatedPermissions).forEach((key) => {
        updatedPermissions[key] = isChecked ? 1 : 0;
      });
      return { ...prev, permissions: updatedPermissions };
    });
  };

  const isAllSelected = () =>
    Object.values(formData.permissions).every((val) => val === 1);

  const isAnySelected = () =>
    Object.values(formData.permissions).some((val) => val === 1);

  const getParentCheckState = (parentKey) => {
    const parentItem = permissionsList.find(
      (item) => item.key === parentKey);
    if (!parentItem?.children) return false;

    const children = parentItem.children;
    const checkedCount = children.filter(
      (child) => formData.permissions[child.key] === 1
    ).length;

    if (checkedCount === 0) return false;
    if (checkedCount === children.length) return true;
    return "indeterminate";
  };

  // =========================
  // FILTERED ROLES
  // =========================
  const filteredRoles = formData.department_id
    ? roles.filter(
      (role) =>
        Number(role.vendor_department_id) === Number(formData.department_id)
    )
    : [];

  // =========================
  // VALIDATION
  // =========================
  const validateForm = () => {
    const newErrors = {};
    // if (!formData.name.trim()) newErrors.name = ["Name is required"];
    // if (!formData.salary.trim()) newErrors.salary = ["Salary is required"];
    // if (!formData.email.trim()) newErrors.email = ["Email is required"];
    if (!formData.role.trim()) newErrors.role = ["Role is required"];
    if (!formData.department.trim())
      newErrors.department = ["Department is required"];
    // if (!formData.address.trim()) newErrors.address = ["Address is required"];
    if (!formData.mobile.trim()) newErrors.mobile = ["Mobile is required"];

    setErrors(newErrors);
    return newErrors;
  };

  // =========================
  // SUBMIT UPDATE (JSON)
  // =========================
  const handleSubmit = async (e) => {
    e.preventDefault();

    const validationErrors = validateForm();
    if (Object.keys(validationErrors).length > 0) {
      setTimeout(() => {
        const firstErrorField = document.querySelector(".is-invalid");
        if (firstErrorField) {
          firstErrorField.focus();
          firstErrorField.scrollIntoView({
            behavior: "smooth",
            block: "center",
          });
        }
      }, 100);
      return;
    }

    try {
      setLoading(true);

      // ✅ Permissions ko Array of Objects mein convert karo
      // const formattedPermissions = Object.keys(formData.permissions)
      //   .filter((key) => formData.permissions[key] === 1)
      //   .map((key) => ({
      //     module: key,
      //     permissions: ["view"],
      //   }));


      // ✅ Permissions ko API format (Name + sub-labels array) me convert karo
      const formattedPermissions = [];

      permissionsList.forEach((item) => {
        // Parent selected hai
        if (formData.permissions[item.key] === 1) {
          if (item.children) {
            // Saare children ka label bhejo
            formattedPermissions.push({
              // module: item.label,
               module: item.key,   
              permissions: item.children.map((child) => child.label),
            });
          } else {
            // Direct (Dashboard)
            formattedPermissions.push({
              // module: item.label,
                 module: item.key,  
              permissions: ["view"],
            });
          }
        } else if (item.children) {
          // Parent unchecked, par kuch children checked hain
          const selectedChildren = item.children
            .filter((child) => formData.permissions[child.key] === 1)
            .map((child) => child.label);
            

          if (selectedChildren.length > 0) {
            formattedPermissions.push({
              // module: item.label,
                 module: item.key,  
              permissions: selectedChildren,
            });
          }
        }
      });
      const payload = {
        id: id,
        name: formData.name,
        email: formData.email,
        mobile: formData.mobile,
        joining_date: formData.joining_date,
        address: formData.address,
        role: formData.role,
        // salary: formData.salary,
        department: formData.department,
        department_id: formData.department_id,
       status: Number(formData.status) === 1 ? 1 : 0,
        permissions: formattedPermissions,
      };

      // if (formData.password) {
      //   payload.password = formData.password;
      // }

      const res = await updateStaff(payload);

      if (res?.success === true) {
        successToast(res?.message || "Staff updated successfully");
        navigate("/staff-list");
      } else {
        errorToast(res?.message || "Something went wrong");
      }
    } catch (error) {
      console.log(error);
      const response = error?.response?.data;

      if (response?.message && typeof response.message === "object") {
        setErrors(response.message);
        const allErrors = Object.values(response.message).flat().join(", ");
        errorToast(allErrors);
      } else {
        errorToast(
          response?.errors || response?.message || "Failed to update staff"
        );
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div className="d-flex align-items-center justify-content-between page-header-breadcrumb">
        <div className="title_member">
          <h4>Edit Employee</h4>
          <nav className="page-breadcrumb">
            <Link to="/">Home</Link>
            <span className="mx-2">/</span>
            <span>Employee</span>
          </nav>
        </div>
        <div className="d-flex flex-wrap gap-2 justify-content-end">
          <button className="add-btn" onClick={() => navigate("/staff-list")}>
            Back
          </button>
        </div>
      </div>

      <div className="main_page">
        <div className="card mt-2">
          <div className="card-body">
            <form onSubmit={handleSubmit} className="row g-3">
              {/* NAME */}
              <div className="col-md-6">
                <label>
                  Name 
                </label>
                <input
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  className="form-control custumform "
                    
                />
                {/* {errors?.name && (
                  <div className="invalid-feedback">{errors.name[0]}</div>
                )} */}
              </div>

              {/* EMAIL */}
              <div className="col-md-6">
                <label>
                  Email 
                </label>
                <input
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  className="form-control custumform "
                />
                {/* {errors?.email && (
                  <div className="invalid-feedback">{errors.email[0]}</div>
                )} */}
              </div>

              {/* MOBILE */}
              <div className="col-md-6">
                <label>
                  Mobile <span className="text-danger">*</span>
                </label>
                <input
                  name="mobile"
                  value={formData.mobile}
                  onChange={(e) => {
                    const value = e.target.value.replace(/\D/g, "");
                    setFormData((prev) => ({ ...prev, mobile: value }));
                    if (errors.mobile) {
                      setErrors((prev) => ({ ...prev, mobile: null }));
                    }
                  }}
                  className={`form-control custumform ${errors?.mobile ? "is-invalid" : ""
                    }`}
                  maxLength={10}
                />
                {errors?.mobile && (
                  <div className="invalid-feedback d-block">
                    {errors.mobile[0]}
                  </div>
                )}
              </div>

              {/* SALARY */}
              {/* <div className="col-md-6">
                <label>
                  Salary
                </label>
                <input
                  name="salary"
                  value={formData.salary}
                  onChange={(e) => {
                    const value = e.target.value.replace(/\D/g, "");
                    setFormData((prev) => ({ ...prev, salary: value }));
                    if (errors.salary) {
                      setErrors((prev) => ({ ...prev, salary: null }));
                    }
                  }}
                  className="form-control custumform "
                />
                {errors?.salary && (
                  <div className="invalid-feedback d-block">
                    {errors.salary[0]}
                  </div>
                )}
              </div> */}

              {/* DEPARTMENT */}
              <div className="col-md-6">
                <label>
                  Department <span className="text-danger">*</span>
                </label>
                <select
                  name="department"
                  value={formData.department}
                  onChange={handleChange}
                  className={`form-control custumform ${errors?.department ? "is-invalid" : ""
                    }`}
                >
                  <option value="">Select Department</option>
                  {departments?.map((dept) => (
                    <option key={dept.id} value={dept.name}>
                      {dept.name}
                    </option>
                  ))}
                </select>
                {errors?.department && (
                  <div className="invalid-feedback d-block">
                    {errors.department[0]}
                  </div>
                )}
              </div>
              <div className="col-md-6">
                <label>
                  Role <span className="text-danger">*</span>
                </label>
                <select
                  name="role"
                  value={formData.role}
                  onChange={handleChange}
                  disabled={!formData.department_id}
                  className={`form-control custumform ${errors?.role ? "is-invalid" : ""
                    }`}
                >
                  <option value="">
                    {formData.department_id
                      ? "Select Role"
                      : "Select Department first"}
                  </option>
                  {filteredRoles?.map((role) => (
                    <option key={role.id} value={role.name}>
                      {role.name}
                    </option>
                  ))}
                </select>
                {errors?.role && (
                  <div className="invalid-feedback d-block">
                    {errors.role[0]}
                  </div>
                )}
              </div>

              {/* PASSWORD */}
              {/* <div className="col-md-6">
                <label>Password (optional)</label>
                <input
                  type="password"
                  name="password"
                  value={formData.password}
                  onChange={handleChange}
                  className="form-control"
                />
              </div> */}

              {/* STATUS */}
              <div className="col-md-6">
                <label>Status</label>
                <select
                  name="status"
                  value={formData.status}
                  onChange={handleChange}
                  className="form-control"
                >
                  <option value={1}>Active</option>
                  <option value={0}>Inactive</option>
                </select>
              </div>

              {/* JOINING DATE */}
              <div className="col-md-6">
                <label>
                  Joining Date <span className="text-danger">*</span>
                </label>
                <input
                  type="date"
                  name="joining_date"
                  value={formData.joining_date}
                  onChange={handleChange}
                  className={`form-control custumform ${errors?.joining_date ? "is-invalid" : ""
                    }`}
                />
                {errors?.joining_date && (
                  <div className="invalid-feedback d-block">
                    {errors.joining_date[0]}
                  </div>
                )}
              </div>

              {/* ADDRESS */}
              <div className="col-md-12">
                <label>
                  Address
                </label>
                <textarea
                  name="address"
                  value={formData.address}
                  onChange={handleChange}
                  rows="3"
                  className="form-control custumform "
                />
                {/* {errors?.address && (
                  <div className="invalid-feedback d-block">
                    {errors.address[0]}
                  </div>
                )} */}
              </div>

              {/* PERMISSIONS */}
              <div className="col-12">
                <div className="d-flex align-items-center justify-content-between mb-3">
                  <h5 className="me-3 mb-0">Permissions</h5>
                  <div className="checkallselectall">
                    <input
                      type="checkbox"
                      id="checkall"
                      onChange={handleSelectAll}
                      checked={isAllSelected()}
                      ref={(el) => {
                        if (el) {
                          el.indeterminate =
                            !isAllSelected() && isAnySelected();
                        }
                      }}
                    />
                    <label htmlFor="checkall" className="ms-1">
                      All Select
                    </label>
                  </div>
                </div>
                <div className="row">
                  {permissionsList.map((item) => (
                    <div key={item.key} className="col-md-4 mb-4">
                      <div className="card shadow-sm border-0">
                        <div className="card-header bg-light d-flex align-items-center">
                          <div className="form-check m-0 w-100">
                            <input
                              className="form-check-input"
                              type="checkbox"
                              id={`perm-${item.key}`}
                              checked={formData.permissions[item.key] === 1}
                              ref={(el) => {
                                if (el && item.children) {
                                  const state = getParentCheckState(item.key);
                                  el.indeterminate =
                                    state === "indeterminate";
                                }
                              }}
                              onChange={() =>
                                handlePermissionTogglecheck(
                                  item.key,
                                  item.children || []
                                )
                              }
                            />
                            <label
                              className="form-check-label fw-bold ms-2"
                              htmlFor={`perm-${item.key}`}
                            >
                              {item.label}
                            </label>
                          </div>
                        </div>

                        {item.children?.length > 0 && (
                          <div className="card-body py-2">
                            <div className="ps-2 border-start">
                              {item.children.map((child) => (
                                <div
                                  key={child.key}
                                  className="form-check mb-2"
                                >
                                  <input
                                    className="form-check-input"
                                    type="checkbox"
                                    id={`perm-${child.key}`}
                                    checked={
                                      formData.permissions[child.key] === 1
                                    }
                                    onChange={() =>
                                      handlePermissionTogglecheck(child.key, [])
                                    }
                                  />
                                  <label
                                    className="form-check-label text-light ms-2"
                                    htmlFor={`perm-${child.key}`}
                                  >
                                    {child.label}
                                  </label>
                                </div>
                              ))}
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  ))}
                </div>
              </div>

              {/* SUBMIT */}
              <div className="col-12 text-end">
                <button type="submit" className="add-btn" disabled={loading}>
                  {loading ? "Updating..." : "Update Employee"}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
}

export default EditStaff;